import React, { FC } from 'react';
import clsx from 'clsx';

import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SVGDotsWrap from '@assets/SVGDotsWrap';

import useStyles from './styles';

interface StyleProps {
  height?: string;
  maxWidth?: string;
  overflow?: string;
  padding?: string;
}
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children: React.ReactNode | React.ReactElement;
  modalCss?: StyleProps;
  className?: string;
  simple?: boolean
}

const Modal: FC<ModalProps> = ({
  open,
  onClose,
  children,
  title,
  description,
  modalCss,
  className,
  simple
}) => {
  const classes = useStyles({ modalCss });

  if (simple) {
    return (
      <Dialog open={open} onClose={onClose} className={classes.dialogSimple}>
        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Dialog open={open} onClose={onClose} className={clsx(classes.dialog, { className })}>
      <div className={classes.topDots}><SVGDotsWrap /></div>
      <div className={classes.bottomDots}><SVGDotsWrap /></div>
      <CloseIcon fontSize="large" onClick={onClose} />
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h1">{title}</Typography>
        <Typography variant="h2">{description}</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {children}
      </DialogContent>
    </Dialog >
  );
};

export default Modal;
